<template>
    <div class="m-summary a-mobile">
        <div class="l-row">
            <div class="l-row__column">
                <div class="m-summary__firstDay">
                    <p class="m-summary__label a-label a-label--big">Podaj datę pierwszej dostawy</p>
                    <date-range-picker
                        ref="picker"
                        :show-dropdowns="true"
                        :auto-apply="true"
                        :ranges="false"
                        :locale-data="localeData"
                        v-model="dateRange"
                        :append-to-body="true"
                        :single-date-picker="true"
                        :date-format="dateFormat"
                        control-container-class="a-control__input m-summary__dateRange"
                    >
                        <template
                            v-if="dateRange"
                            v-slot:input="picker"
                        >
                            {{ formatDate(picker.startDate) }}
                        </template>
                    </date-range-picker>
                    <br /><br />
                </div>
                <p class="m-summary__label a-label a-label--big">Twój rabat</p>
                <p class="a-price a-price--left"><span class="a-price__discount">{{ totalDiscount }}</span> <span class="a-price__time">/ 7 dni</span></p>
                <p class="a-price a-price--left"><span class="a-price__discount">{{ totalDiscountMonth }}</span> <span class="a-price__time">/ 1 mc</span></p>
            </div>
            <div class="l-row__column">
                <p class="m-summary__label a-label a-label--big">Podsumowanie zamówienia</p>
                <p class="a-title a-title--subtitle m-summary__deliveryTitle">Dostawy będą realizowane na adresy:</p>
                <p
                    v-for="(address, idx) in customerAddresses"
                    v-bind:key="idx"
                    class="m-summary__deliveryAddress"
                >
                    <span v-if="address.address">{{ address.address }}</span>
                    <span v-else>{{ address.street }} {{ address.number }}, {{ address.postcode }} {{ address.city }}</span>
                </p>
            </div>
            <div class="l-row__column m-summary__summary">
                <p class="m-summary__title">Łączny koszt dostaw netto:</p>
                <p class="a-price"><span class="a-price__price">{{ totalAmount }}</span> <span class="a-price__time">/ 7 dni</span></p>
                <p class="a-price">{{ totalAmountMonth }} <span class="a-price__time">/ 1 mc</span></p>
                <o-notifications
                    :is-static="true"
                    name="cart-summary"
                />
                <div class="m-summary__buttons a-mobile__buttons">
                    <button
                        class="m-summary__button a-button"
                        @click="resetOrder"
                    >
                        Zacznij od początku
                    </button>
                    <button
                        class="m-summary__button a-button a-button--secondary"
                        :class="{'a-button--disabled':someAddressesDoNotHaveOrder}"
                        @click="handleSubmit"
                    >
                        Podsumowanie
                        <svg class="a-button__icon" width="6" height="8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.625 7l3.328-2.958-3.328-2.959" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                    </button>
                </div>
            </div>
        </div>
        <o-modal
            name="thresholdAmount"
            :disable-close="true"
        >
            <template slot="content" slot-scope="props">
                <p class="a-text a-text--big a-text--center">
                    {{ props.payload.message }}
                </p>
                <br />
                <a-button
                    class="a-button--primary"
                    @click="resetOrder"
                >Powrót do początku</a-button>
            </template>
        </o-modal>
    </div>
</template>

<script>
import moment from 'moment'
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'

export default {
    components: {
        DateRangePicker
    },
    watch: {
        minimumDate() {
            this.updateMinimumValue()
        },
        totalAmountValue() {
            this.checkAmount()
        },
        thresholdAmount() {
            this.checkAmount()
        }
    },
    computed: {
        dateRange: {
            get() {
                const date = this.$store.getters.customerAddressField(this.currentAddressId, 'dateFrom')
                return {
                    startDate: date,
                    endDate: date
                }
            },
            set(dateRange) {
                this.$store.dispatch('setCustomerAddressField', {
                    addressId: this.currentAddressId,
                    field: 'dateFrom',
                    value: moment(dateRange.startDate).format('YYYY-MM-DD')
                })
            }
        },
        currentAddressId() {
            return this.$store.getters.currentAddressId
        },
        totalAmount() {
            return this.$store.getters.totalAmount.toFixed(2).toPLN()
        },
        totalAmountWithoutDiscount() {
            return this.$store.getters.totalAmountWithoutDiscount(this.currentAddressId).toFixed(2).toPLN()
        },
        totalDiscount() {
            return this.$store.getters.totalDiscount.toFixed(2).toPLN()
        },
        someAddressesDoNotHaveOrder() {
            let someAddressesDoNotHaveOrder = false
            for(let i = 0; i <= this.customerAddresses.length - 1; i++) {
                if(this.$store.getters.weekAmount(i) === 0) {
                    someAddressesDoNotHaveOrder = true
                }
            }
            return someAddressesDoNotHaveOrder
        },
        totalAmountValue() {
            return this.$store.getters.totalAmount
        },
        totalAmountMonth() {
            return (this.$store.getters.totalAmount * 4).toFixed(2).toPLN()
        },
        totalDiscountMonth() {
            return (this.$store.getters.totalDiscount * 4).toFixed(2).toPLN()
        },
        customerAddresses() {
            return this.$store.getters.customerAddresses
        },
        minimumValue() {
            return this.$store.getters.minimumValue
        },
        minimumDate() {
            return this.$store.getters.minimumDate
        },
        maximumDate() {
            return this.$store.getters.maximumDate
        },
        offDays() {
            return this.$store.getters.offDays
        },
        thresholdAmount() {
            return this.$store.getters.thresholdAmount
        },
        thresholdAmountMessage() {
            return this.$store.getters.thresholdAmountMessage
        },
        localeData() {
            return {
                firstDay: 1,
                format: 'DD-MM-YYYY',
                daysOfWeek: ['Nd', 'Pon', 'Wt', 'Śr', 'Czw', 'Pt', 'Sob'],
                monthNames: ['Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec', 'Lipiec', 'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień']
            }
        }
    },
    methods: {
        formatDate(date) {
            return moment(date).format('DD.MM.YYYY')
        },
        dateFormat(classes, date) {
            classes.disabled = moment(date).isBefore(this.minimumDate) || this.offDays.includes(moment(date).format('YYYY-MM-DD')) || moment(date).isAfter(this.maximumDate)
            return classes
        },
        resetOrder() {
            this.$store.dispatch('resetState').then(() => {
                this.$router.push({ name: 'delivery-address' })
            })
        },
        handleSubmit() {
            this.$store.dispatch('fetchSettings').then(() => {
                this.$store.dispatch('checkMinimumCartDate')
            })
            if(this.someAddressesDoNotHaveOrder) {
                this.$store.dispatch('addNotification', {
                    type: 'danger',
                    content: 'Nie wszystkie adresy posiadają zamówienie!',
                    name: 'cart-summary',
                    limit: 0
                })
                return true
            }
            // if minimum value is not reached
            const minimumValueNotReached = this.customerAddresses.some((address, idx) => {
                // if day with order
                for(let day = 0; day < 5; day++) {
                    if(this.$store.getters.isValueMinimum(day, idx)) {
                        return true
                    }
                }
            })
            if(minimumValueNotReached) {
                this.$store.dispatch('addNotification', {
                    type: 'danger',
                    content: 'Minimum logistyczne nie zostało osiągnięte',
                    name: 'cart-summary',
                    limit: 0
                })
            } else {
                this.$router.push({ name: 'checkout' })
            }
        },
        updateMinimumValue() {
            if(this.minimumDate !== null && this.minimumDate !== undefined) {
                if(moment(this.dateRange.startDate).isBefore(this.minimumDate)) {
                    this.$store.dispatch('setCustomerAddressField', {
                        addressId: this.currentAddressId,
                        field: 'dateFrom',
                        value: this.minimumDate
                    })
                }
            }
        },
        checkAmount() {
            if(this.thresholdAmount !== null && this.totalAmountValue > this.thresholdAmount) {
                this.$store.dispatch('modalHide')
                this.$store.dispatch('modalShow', {
                    name: 'thresholdAmount',
                    payload: {
                        message: this.thresholdAmountMessage
                    }
                })
            }
        }
    },
    created() {
        this.$store.dispatch('fetchOffDays')
        this.updateMinimumValue()
    }
}
</script>
